import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useProjects } from "@/contexts/ProjectContext";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import PageHeader from "@/components/dashboard/PageHeader";
import { toast } from "sonner";

export default function ConversionBlocksPage() {
  const { activeProjectId } = useProjects();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!activeProjectId) return;
    api.get(`/conversion-blocks/${activeProjectId}`).then(({ data }) => setRows(data));
  }, [activeProjectId]);

  return (
    <DashboardLayout>
      <PageHeader
        overline="Conversion Blocks"
        title="Reusable CTA blocks for every funnel stage."
        description="Drop these into briefs, articles, and category pages. A/B variants ready."
      />

      <div className="grid md:grid-cols-2 gap-5">
        {rows.map((b) => (
          <div key={b.id} className="bg-white border border-border rounded-sm p-6 hover:border-gold-500 transition-colors" data-testid={`conv-block-${b.id}`}>
            <div className="flex items-center justify-between mb-3">
              <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{b.placement} · {b.funnel_stage}</span>
              <span className="text-[10px] uppercase tracking-widest text-gold-600">Variant {b.variant}</span>
            </div>
            <h3 className="font-serif text-2xl text-navy-900">{b.headline}</h3>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{b.body}</p>
            <div className="mt-5 flex items-center justify-between gap-3">
              <button
                className="px-4 py-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold rounded-sm text-sm"
                onClick={() => { navigator.clipboard?.writeText(`${b.headline}\n\n${b.body}\n\nCTA: ${b.cta}`); toast.success("Block copied to clipboard"); }}
                data-testid={`copy-block-${b.id}`}
              >
                Copy block
              </button>
              <span className="text-sm font-medium text-navy-900">CTA: {b.cta}</span>
            </div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
